import Header from "./app/headers";
import Container from "./app/container";
import Footer from "./app/footers";

const Template = ({
  children,
  header,
  headerMob,
  headerWeb,
  footer,
  footerMob,
  footerWeb,
  showIcon
}) => {
  const renderHeader = () => {
    if (header) {
      return <Header headerMob={headerMob}  showIcon={showIcon} headerWeb={headerWeb} />;
    }
  };
  const renderContainer = () => {
    return <Container header={header}>{children}</Container>;
  };
  const renderFooter = () => {
    if (footer) {
      return <Footer footerMob={footerMob} footerWeb={footerWeb} />;
    }
  };

  return (
    <>
      {renderHeader()}
      {renderContainer()}
      {renderFooter()}
    </>
  );
};

Template.defaultProps = {
  header: true,
  headerWeb: true,
  headerMob: true,
  footer: false,
  footerMob: false,
  footerWeb: false,
  showIcon: true,
};

export default Template;
